import type { EntryPointComponent } from 'react-relay';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { serviceDeskPortalClassicSettingsResource } from '@jira/spa-apps__project-settings-service-desk-classic-portal-settings/src/serviceDeskPortalClassicSettingsResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskPortalSettingsRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskPortalSettingsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { Route } from '@atlassian/react-resource-router';
import ServiceDeskClassicPortalSettings, {
	LazyProjectSettingsServiceDeskClassicPortalSettings,
} from './ui/service-desk-classic-portal-settings/index.tsx';

const projectSettingsServicedeskPortalSettingsPageEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-project-settings-service-desk-classic-portal-settings", jiraSpaEntry: "async-project-settings-service-desk-classic-portal-settings" */ '@jira/spa-apps__project-settings-service-desk-classic-portal-settings/src/ClassicPortalSettings.tsx',
			{ entryFsSsrLiftImportToModule: false },
		),
		getPreloadProps: () => ({}),
	},
});

export const projectSettingsServicedeskPortalSettingsRouteEntry: Route = createEntry(
	projectSettingsServicedeskPortalSettingsRoute,
	() => ({
		group: 'project-settings-servicedesk',

		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_batch_2')
			? undefined
			: ServiceDeskClassicPortalSettings,

		entryPoint: () =>
			fg('nike_entrypoint_migration_batch_2')
				? projectSettingsServicedeskPortalSettingsPageEntryPoint
				: undefined,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getServiceDeskSettingsResources(),
			getConsolidationStateResource(),
			serviceDeskPortalClassicSettingsResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskClassicPortalSettings],

		meta: {
			reporting: {
				id: APP_NAMES.PORTAL_SETTINGS,
				packageName: toPackageName(APP_NAMES.PORTAL_SETTINGS),
				teamName: 'jsd-shield',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
